<template>
  <div class="editor-page page">
    <loader
      v-if="loading"
      :show="item == null"
      :width="40"
      :height="40"
    ></loader>
    <top-bar
      :title="'Editor Categorie ' + title"
      :loading="loading"
      :preview="''"
      :action="false"
      :actionIsValid="isValid"
      @lang="
        (l) => {
          lang = l;
        }
      "
    ></top-bar>
    <Tree
      ref="tree"
      :value="treeData"
      :ondragend="ondragend"
      :eachDroppable="eachDroppable"
      :triggerClass="'drag-handle'"
      @drop="update"
    >
      <div slot-scope="{ node, index, path, tree }">
        <div class="main-content">
          <div class="controls" v-if="canSave">
            <span class="drag-handle"><DragHandle /></span>
            <button
              v-if="node.children.length > 0"
              @click="tree.toggleFold(node, path)"
            >
              <level-switch :open="!node.$folded" />
            </button>
          </div>
          <div class="content">
            <strong>{{ node.id }}</strong> - {{ node.contents[lang].title }}
          </div>
          <div class="actions" v-if="canSave">
            -
            <button
              @click="
                () => {
                  node.edit = !node.edit;
                  if (node.edit) {
                    $set(node, 'clone', JSON.parse(JSON.stringify(node)));
                  } else {
                    delete node.clone;
                  }
                }
              "
            >
              modifica
            </button>
            <button @click="deleteCategory(node)">elimina</button>
          </div>
        </div>
        <div class="edit-panel d-flex align-items-center" v-if="node.edit">
          <button @click="pickImage(node.clone.cover)">
            <img
              class="cover"
              :src="node.clone.cover.url_thumb"
              :alt="node.clone.contents[lang].title"
            /><br />
            <small> fai click per cambiare l'immagine </small>
          </button>
          <form class="form ml-4">
            <div class="form-group">
              <label for="titolo">Titolo</label>
              <input
                v-model="node.clone.contents[lang].title"
                type="text"
                class="form-control"
                id="titolo"
              />
            </div>

            <div class="form-group">
              <label for="slug">Slug</label>
              <input
                v-model="node.clone.contents[lang].slug"
                type="text"
                class="form-control"
                id="slug"
              />
            </div>

            <button
              type="button"
              @click="
                () => {
                  node.cover = Object.assign(
                    {},
                    JSON.parse(JSON.stringify(node.clone.cover))
                  );
                  node.contents = Object.assign(
                    {},
                    JSON.parse(JSON.stringify(node.clone.contents))
                  );
                  saveNode(node);
                }
              "
              class="btn btn-secondary"
            >
              Salva
            </button>
            <button
              type="button"
              @click="
                () => {
                  delete node.clone;
                  node.edit = false;
                }
              "
              class="btn btn-primary"
            >
              Annulla
            </button>
          </form>
        </div>
      </div>
    </Tree>

    <div class="form form-section" v-if="canSave">
      <h5>
        Aggiungi categoria
        <lang-switcher
          class="ls"
          v-model="newCatLang"
          :langs="$available_langs"
          :btnClass="'light'"
        >
        </lang-switcher>
      </h5>
      <div class="form-group">
        <label>Titolo</label>
        <input
          type="text"
          class="input form-control"
          v-model="newCatInfo[newCatLang].title"
        />
      </div>

      <div class="form-group">
        <label>Slug</label>
        <input
          type="text"
          class="input form-control"
          v-model="newCatInfo[newCatLang].slug"
        />
      </div>

      <button class="btn btn-primary" type="button" @click="addCategory()">
        aggiungi
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.he-tree {
  font-size: 1rem;

  .tree-children {
    transition-duration: 0.4s;
    transition-property: transform;
  }
  .tree-node {
    background-color: white;
    border: 1px solid #ccc;
    margin-bottom: 5px;
    padding: 5px;
    cursor: pointer;

    &:hover {
      .actions {
        opacity: 1;
      }
    }
  }

  .actions button,
  .controls button {
    border: none;
    color: #007bff;
    background: transparent;
  }
  .drag-handle {
    cursor: grab;
    padding: 10px;
  }

  .main-content {
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }

  .actions {
    margin-left: 10px;
    color: #007bff;
    font-size: 0.7rem;
    opacity: 0;
    transition: 0.4s all;
  }
  .edit-panel {
    margin: 10px;
    background-color: white;
    border: 1px solid #ccc;
    padding: 5px;
  }

  img.cover {
    width: 200px;
    height: 200px;
    object-fit: contain;
    background-color: #f1f1f1;
  }
}

.form-section {
  border: 1px solid #ccc;
  margin: 1rem 0;
  padding: 1rem;
  background-color: white;

  .btn.light {
    border: none !important;

    &.btn-primary {
      background-color: transparent;
      border-color: #7a9e9f;
      color: #000;
    }
  }

  .ls {
    display: inline;
    padding: 5px;
  }
}
</style>
<script>
import { DragHandle, LevelSwitch } from "@/components/icons";

import {
  Tree, // Base tree
  Fold,
  Check,
  Draggable, // plugins
  foldAll,
  unfoldAll,
  cloneTreeData,
  walkTreeData,
  getPureTreeData, // utils
} from "he-tree-vue";
import "he-tree-vue/dist/he-tree-vue.css"; // base style
import TopBar from "@/components/altrama/TopBar";
import Button from "@/components/Inputs/Button.vue";
const pickImageHelper =
  require("@/components/altrama/richeditor/image-picker").default;

import LangSwitcher from "@/components/altrama/LangSwitcher";
export default {
  components: {
    Tree: Tree.mixPlugins([Fold, Draggable]),
    TopBar,
    DragHandle,
    LevelSwitch,
    Button,
    LangSwitcher,
  },

  props: ["id", "path", "parent"],

  data() {
    return {
      loading: false,
      lang: "it",
      isValid: false,
      treeData: [],
      title: "",
      canSave: false,
      newCatLang: "it",
      newCatInfo: this.$contentTemplate({
        title: "",
        subtitle: "",
        slug: "",
      }),
    };
  },

  provide() {
    return { parentValidator: this.$validator };
  },

  created: async function () {
    if (!(await this.$api.user.can("category-view"))) {
      this.$router.replace("/not-found");
      return;
    }

    if ((await this.$api.user.can("category-edit"))) {
      this.canSave = true;
    }
    this.updateResource();
  },
  watch: {
    id: function () {
      this.updateResource();
    },
  },

  methods: {
    deleteCategory(node) {
      if (
        confirm(
          "La rimozione della categoria comporta la modifica dei contenuti ad essa associata.L'operazione non è reversibile. Vuoi continuare?"
        )
      ) {
        let self = this;
        this.$api.categories.remove(node.id).then((data) => {
          self.$notifyVue(
            "top",
            "center",
            data.status,
            data.data.message,
            "ti-check"
          );

          self.updateResource();
        });
      }
    },
    addCategory() {
      let self = this;

      let object = {
        parent_id: self.id,
        contents: this.newCatInfo,
      };

      this.$api.categories.save("new", object).then((data) => {
        self.newCatInfo = self.$contentTemplate({
          title: "",
          subtitle: "",
          slug: "",
        });

        self.$notifyVue(
          "top",
          "center",
          data.status,
          data.data.message,
          "ti-check"
        );

        self.updateResource();
      });
    },
    saveNode(node) {
      let self = this;
      this.$api.categories.save(node.id, node).then((data) => {
        self.$notifyVue(
          "top",
          "center",
          data.status,
          data.data.message,
          "ti-check"
        );
      });
    },
    update(store) {
      let node = store.dragNode;

      node.order = store.targetPath[store.targetPath.length - 1];

      if (store.startPath[store.startPath.length - 1] < node.order) {
        node.order--;
      }

      let updateObj = false;
      let parent = this.$refs.tree.getNodeParentByPath(store.targetPath);
      if (parent === undefined) {
        updateObj = {};
        let index = 0;
        for (let itm of this.treeData) {
          this.treeData[index].order = index;
          updateObj[itm.id] = index;
          index++;
        }
      } else {
        updateObj = {};
        let index = 0;
        for (let itm of parent.children) {
          itm.order = index;
          updateObj[itm.id] = index;
          index++;
        }
      }

      if (updateObj) {
        let self = this;
        this.$api.categories.update_order(updateObj).then((data) => {
          self.$notifyVue(
            "top",
            "center",
            data.status,
            data.data.message,
            "ti-check"
          );
        });
        console.info(updateObj);
      }
    },
    ondragend(tree, store) {
      return (
        (store.startPath.length === 1 && store.targetPath.length === 1) ||
        (store.startPath.length === 2 &&
          store.targetPath.length === 2 &&
          store.startPath[0] == store.targetPath[0])
      );
    },
    eachDraggable(path, tree, store) {
      const node = tree.getNodeByPath(path);
      return node.level > 0;
    },
    eachDroppable(path, tree, store) {
      const node = tree.getNodeByPath(path);
      return node === undefined || node.level == 0;
    },
    pickImage(field) {
      pickImageHelper(this.$el, 1).then((details) => {
        if (details.length > 0) {
          field.id = details[0].id;
          field.url_thumb = details[0].url_thumb;
          field.url = details[0].url;
        }
      });
    },

    updateResource() {
      this.$api.categories.index(this.id).then((data) => {
        function walkTree(tree, callback) {
          for (let node of tree) {
            callback(node);
            if (node.children) {
              walkTree(node.children, callback);
            }
          }
          return tree;
        }

        if (data.status == "success") {
          let treeData = [];
          var obj = data.data;
          for (let item of obj.children) {
            item.index = treeData.length;
            treeData.push(item);
          }
          this.title = obj.title;
          this.treeData = walkTree(treeData, (node) => {
            node.edit = false;
            node.$folded = true;
          });
        }
      });
    },
  }, // methods
};
</script>
